<div class="row wp-image-text">
  @if (isBrandLogoImageShown) {
    <div class="wp-image-text-image" style="text-align: center;">
      <!-- <img class="img-fluid mx-auto d-block" [src]="brandLogoImage" > -->
        <img class="mx-auto d-block" [src]="brandLogoImage" [height]="imageHeight">
    </div>
  }
<!-- 
    <div class="wp-image-text-text">
      <h4 class="text-center">{{brandName}}</h4>
    </div>
</div>
 -->
<!-- 
@if (isHeaderTextShown) {
  <div class="row alert alert-info">
    <h5 class="text-center">{{headerText}}</h5>
  </div>
}
 -->
@if (isInnerHtmlShown) {  
    <!-- <div class="text-center">
      <div [innerHTML]="innerHtml"></div>
    </div> -->
  <div class="center-container">
    <div [innerHTML]="innerHtml"></div>
  </div>
}

